import { RECEIVE_BACK_IN_STOCK_VARIANTS } from "../constants";
import { getNotifyVariants } from "../../../../services/backInStock";

export const getBackInStock = () => async dispatch => {
  const notifyVariants = await getNotifyVariants(dispatch);
  let variantIds;
  if (notifyVariants) {
    variantIds = notifyVariants.variantIds;

    dispatch({
      type: RECEIVE_BACK_IN_STOCK_VARIANTS,
      payload: {
        variantIds
      }
    });
  }

  return variantIds || [];
};
